import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

function ResetPassword () {

    const { email } = useParams();

    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    async function resetPassword() {
        setSubmitting(true);

        try {
            const form = document.getElementById("form-reset-password");
            const formData = new FormData(form);
            formData.append("email", email);

            const response = await axios.post(
                baseUrl + "/api/reset-password",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Reset password", response.data.message, "success")
                    .then(function () {
                        navigate("/login");
                    });
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Reset password</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Reset password</li>
                        </ol>
                    </nav>
                </div>
            </div>

             <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Reset password</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-5 text-center">Please enter a new password below to replace your old one and regain secure access to your account.</p>

                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    resetPassword();
                                } } id="form-reset-password">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" name="token" placeholder="Verification code" required />
                                                <label>Verification code</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input type="password" className="form-control" name="password" placeholder="New password" required />
                                                <label>New password</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input type="password" className="form-control" name="password_confirmation" placeholder="Confirm password" required />
                                                <label>Confirm password</label>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <button className="btn btn-primary w-100 py-3" type="submit"
                                                disabled={ submitting }>Reset Password</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ResetPassword;